import { useState } from 'react';

import styled, { css } from 'styled-components';

import { Calendar2Line, CalendarIcon } from '@assets/icons';
import { DateType, formatShortLocalDate } from '@utils/dateUtil';
import ResponsiveApplyButton from '@components/views/components/listing/drawer/ResponsiveApplyButton/ResponsiveApplyButton';
import ResponsiveSearchDrawerItem from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import { LocationAnimationErrorBox } from '@components/views/components/listing/ListingStyle';
import { FlightSearchInputDrawerType } from '@components/views/flight/types';
import ResponsiveSingleDatePicker from '@components/DatePicker/SingleDatePicker/ResponsiveSingleDatePicker';
import { DayPickerSingleDateControllerProps } from '@components/DatePicker/SingleDatePicker/SingleDatePicker';
import ResponsiveSearchInputDrawer from '@components/views/components/listing/ResponsiveSearchInputDrawer/ResponsiveSearchInputDrawer';

import { getSingleDatePickerPlaceholder } from './utils';
import { ButtonWrapper } from './styled';

const searchLabel = 'Gidiş Tarihiniz?';

const SingleDateInputDrawer = styled(ResponsiveSearchInputDrawer)<{
  $useTravelPlanningSurface?: boolean;
}>`
  ${({ $useTravelPlanningSurface, theme }) =>
    $useTravelPlanningSurface &&
    css`
      background-color: ${theme.palette.white};
    `}
`;

const ResponsiveSingleDateSelectDrawer = ({
  date,
  onDateChange,
  title,
  subTitle,
  placeholder,
  drawerTitle,
  arrowIcon,
  error,
  isOutsideRange,
  useTravelPlanningSurface,
}: Pick<
  DayPickerSingleDateControllerProps,
  'date' | 'onDateChange' | 'isOutsideRange'
> &
  FlightSearchInputDrawerType & {
    error?: boolean;
    useTravelPlanningSurface?: boolean;
    inputComponent:
      | 'shopAndFlyHomePageCarRental'
      | 'shopAndFlyHomePageFlight'
      | 'shopAndFlyHomePageHotel'
      | 'setur';
  }) => {
  return (
    <SingleDateInputDrawer
      $useTravelPlanningSurface={useTravelPlanningSurface}
      icon={Calendar2Line}
      title={title}
      subTitle={subTitle}
      placeholder={placeholder}
      drawerTitle={drawerTitle}
      arrowIcon={arrowIcon}
      startDate={date}
    >
      {(hideModal) => (
        <ResponsiveSingleDateSelect
          date={date}
          onDateChange={onDateChange}
          hideModal={hideModal}
          error={error}
          isOutsideRange={isOutsideRange}
        />
      )}
    </SingleDateInputDrawer>
  );
};

const ResponsiveSingleDateSelect = ({
  date,
  onDateChange,
  hideModal,
  error,
  isOutsideRange,
}: Pick<
  DayPickerSingleDateControllerProps,
  'date' | 'onDateChange' | 'isOutsideRange'
> & {
  hideModal: () => void;
  error?: boolean;
}) => {
  const [localDate, setLocalDate] = useState<DateType | null>(date);

  const handleDateChange = (date: DateType | null) => {
    setLocalDate(date);
  };

  const inputSubTitle = getSingleDatePickerPlaceholder(localDate);

  const onSubmit = () => {
    if (localDate) {
      onDateChange(localDate);
      setLocalDate(null);
      hideModal();
    }
  };

  return (
    <>
      <LocationAnimationErrorBox hasError={error || false}>
        <ResponsiveSearchDrawerItem
          icon={CalendarIcon}
          title={searchLabel}
          subTitle={formatShortLocalDate(inputSubTitle)}
          placeholder='Gidiş Tarihi'
        />
      </LocationAnimationErrorBox>

      <ResponsiveSingleDatePicker
        date={localDate}
        onDateChange={handleDateChange}
        isOutsideRange={isOutsideRange}
      />

      <ButtonWrapper>
        <ResponsiveApplyButton onClick={onSubmit} />
      </ButtonWrapper>
    </>
  );
};

export default ResponsiveSingleDateSelectDrawer;
